<template>
  <div>
    <el-dialog
      v-model="dialogVisible"
      :width="isMobile ? '90%' : '700px'"
      :title="t('coins.detail')"
      destroy-on-close
      append-to-body
      :before-close="handleClose"
    >
      <template #footer></template>
      <div class="d-flex flex-column">
        <div class="d-flex justify-content-between">
          <h4 class="text-muted">{{ t('coins.currentSales') }}</h4>
          <h4 class="text-primary">{{ n(total) }}</h4>
        </div>
        <div class="d-flex justify-content-between">
          <h4 class="text-muted">{{ t('coins.nextTotal') }}</h4>
          <h4 class="text-muted">{{ n(nextTotal) }}</h4>
        </div>
      </div>
      <el-divider />
      <h5 class="text-center">
        {{ dt(product.name_translations) }}
      </h5>
      <div v-for="assort in product.assorts" :key="assort.id">
        <h6 class="mt-5">
          {{ dt(assort.name_translations) }}
          <div v-if="assort.distribute_settings" class="text-danger">
            (
            <span>{{ t('coins.availableSales') }}: {{ assort.inventory }}</span>
            <span v-if="assort.distribute_settings.limit_order_quantity != -1">, {{ t('coins.memberOnly') }}: {{ assort.distribute_settings.limit_order_quantity }}</span>
            )
          </div>
        </h6>

        <el-table
          :data="levels"
          style="width: 100%"
          stripe
          fit
        >
          <el-table-column :label="t('coins.level')">
            <template #default="scope">
              <div v-if="scope.row?.id == distributor?.level_info?.id">
                <span class="text-primary mr-3">
                  {{ scope.row?.name }} 
                  <span v-if="scope.row?.level_order_accumulated_amount">
                    ({{ t('coins.upgradeConditions') }} 
                    {{ n(scope.row?.level_order_accumulated_amount) }} 
                    {{ t('coins.turnover') }})
                  </span>
                </span>
                <span class="text-danger">({{ t('coins.yourLevel') }})</span>
              </div>
              <div v-else>
                {{ scope.row?.name }} <span v-if="scope.row?.level_order_accumulated_amount">(升級條件 {{ n(scope.row?.level_order_accumulated_amount) }} 營業額)</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="t('coins.pv')" align="right" width="70">
            <template #default="scope">
              <div v-if="!!scope.row?.coin_percentage && !!assort?.coin_reward"></div>
              {{ n(Math.floor(scope.row?.coin_percentage * assort?.coin_reward /100)) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, breakpoint } from "../../utils"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Boolean,
  product: Object,
  distributor: Object,
  levels: Array,
})
const emit = defineEmits(['update:modelValue'])

const { t, n, locale } = useI18n()
const dialogVisible = useVModel(props, 'modelValue', emit)

const state = reactive({
})

const isMobile = computed(() => breakpoint.value.xs)
const total = computed(() => props.distributor?.order_accumulated_amount || 0)
const nextTotal = computed(() => props.distributor?.level_info?.order_accumulated_amount - props.distributor?.order_accumulated_amount || 0)

const handleClose = () => {
  dialogVisible.value = false
}
</script>

<style scoped></style>